import styled from '@emotion/styled';

const LabelText = styled.div`
    font-family: ${props => props.theme.fontFamily};
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 8px;
    color: ${props => props.theme.primaryFontColor};
    `;

export default LabelText;